export const MILITAO_URL = import.meta.env.VITE_MILITAO_URL;
export const LUKITA_URL = import.meta.env.VITE_LUKITA_URL;
export const COURTOIS_URL = import.meta.env.VITE_COURTOIS_URL;
export const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
export const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY;
export const STRIPE_CUSTOMER_PORTAL_URL = import.meta.env
  .VITE_STRIPE_CUSTOMER_PORTAL_URL;
export const POSTHOG_HOST = import.meta.env.VITE_POSTHOG_HOST;
export const POSTHOG_KEY = import.meta.env.VITE_POSTHOG_KEY;
export const INTERCOM_APP_ID = import.meta.env.VITE_INTERCOM_APP_ID;
export const MAPBOX_KEY = import.meta.env.VITE_MAPBOX_KEY;
export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;

export const DEFAULT_ITEMS_PER_PAGE = 10;
export const DEFAULT_CURRENT_PAGE = 1;
